(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["igk-attrac-layers"] && !Shopify.designMode) return;
  try {
    (() => {
  const tracked = new Map();
  let frame = 0;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(refresh);
  };
  const resized = new ResizeObserver(schedule);

  function refresh() {
    frame = 0;
    let offset = 0;

    for (const [bar, observer] of tracked) {
      if (!bar.isConnected) {
        observer.disconnect();
        resized.unobserve(bar);
        tracked.delete(bar);
      }
    }

    document.querySelectorAll('.aph_bar_bar').forEach(bar => {
      if (bar.querySelector('.hidBarPosition')?.value !== 'top') return;
      const style = getComputedStyle(bar);
      if (style.position !== 'fixed') return;

      if (!tracked.has(bar)) {
        const observer = new MutationObserver(schedule);
        observer.observe(bar, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        resized.observe(bar);
        tracked.set(bar, observer);
      }

      if (!bar.classList.contains('igk-attrac-fixed-bar')) bar.classList.add('igk-attrac-fixed-bar');
      if (bar.parentElement !== document.body) document.body.appendChild(bar);

      const rect = bar.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0) {
        offset = Math.max(offset, rect.bottom);
      }
    });

    const value = Math.max(0, Math.ceil(offset)) + 'px';
    if (document.documentElement.style.getPropertyValue('--igk-attrac-top-offset') !== value) {
      document.documentElement.style.setProperty('--igk-attrac-top-offset', value);
    }
  }

  const containsBar = node => node instanceof Element &&
    (node.matches('.aph_bar_bar') || node.querySelector('.aph_bar_bar'));

  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(containsBar))) {
      schedule();
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["igk-coupon-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  if (document.getElementById('igk-benq-offer')) return;
  const box = document.getElementById('igk-coupon-feedback');
  if (!box || box.dataset.bound) return;
  box.dataset.bound = 'true';
  const text = box.dataset;
  const title = box.querySelector('.igk-coupon-feedback__title');
  const saving = box.querySelector('.igk-coupon-feedback__saving');
  const productLabel = box.querySelector('.igk-coupon-feedback__product');
  let productContext = null;
  let lastCart = null;
  try { productContext = JSON.parse(document.getElementById('igk-coupon-product')?.textContent || 'null'); } catch (_) {}
  const detail = box.querySelector('.igk-coupon-feedback__detail');
  const badge = box.querySelector('.igk-coupon-feedback__code');
  const root = window.Shopify?.routes?.root || '/';
  const storageKey = 'igk-attrac-coupon-v1';
  let sequence = 0;
  let walletRevision = 0;
  let dismissTimer;
  let active = null;
  let queue = Promise.resolve();
  let dismissed = false;
  try {
    const previous = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (previous && Date.now() - previous.at < 7200000) active = previous;
  } catch (_) {}
  const productName = () => productContext?.title?.match(/^BenQ\s+[A-Za-z0-9-]+/i)?.[0] || productContext?.title || '';
  const normal = value => String(value || '').trim().toUpperCase();
  const setWalletDiscount = code => {
    const value = String(code || '').trim();
    if (value.length > 100) return;
    walletRevision += 1;
    document.cookie = 'discount_code=' + encodeURIComponent(value) + '; Path=/; Max-Age=' + (value ? 7200 : 0) + '; SameSite=Lax; Secure';
  };
  const syncWalletDiscount = (cart, preferredCode = active?.code) => {
    if (!Array.isArray(cart?.discount_codes)) return;
    const codes = cart.discount_codes.filter(item => item.code);
    const selected = codes.find(item => normal(item.code) === normal(preferredCode)) ||
      codes.find(item => item.applicable) || codes[0];
    setWalletDiscount(selected?.code);
  };
  const updateCouponButtons = (code, confirmed, pending = false) => {
    for (const button of document.querySelectorAll('button[data-igk-coupon-code]')) {
      if (normal(button.dataset.igkCouponCode) !== normal(code)) continue;
      button.dataset.originalLabel ||= button.getAttribute('aria-label') || code;
      button.dataset.couponApplied = String(confirmed);
      button.setAttribute('aria-busy', String(pending));
      button.setAttribute('aria-label', confirmed ? code + ': ' + text.saved : button.dataset.originalLabel);
    }
  };
  const writeState = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(active)); } catch (_) {}
  };
  const hide = () => {
    box.hidden = true;
    document.documentElement.classList.remove('igk-coupon-feedback-visible');
    dismissed = true;
    clearTimeout(dismissTimer);
  };
  const scheduleHide = () => {
    clearTimeout(dismissTimer);
    if (box.dataset.state !== 'pending') dismissTimer = setTimeout(hide, 5000);
  };
  const show = (state, code, heading, message, amount, hasItems) => {
    box.dataset.state = state;
    title.textContent = heading;
    detail.textContent = message;
    badge.textContent = code;
    saving.textContent = amount ? text.savings + ' ' + amount : '';
    saving.hidden = !amount;
    productLabel.hidden = true;
    if (!dismissed) {
      box.hidden = true;
      document.documentElement.classList.remove('igk-coupon-feedback-visible');
    }
    scheduleHide();
  };
  function couponSavings(cart, code) {
    const matches = application => normal(application?.code || application?.title) === normal(code);
    let cents = (cart.cart_level_discount_applications || []).reduce((total, application) =>
      total + (matches(application) ? Number(application.total_allocated_amount) || 0 : 0), 0);
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        if (matches(allocation.discount_application)) cents += Number(allocation.amount) || 0;
      }
    }
    return Math.max(0, cents);
  }
  function formatCurrency(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: currency || 'USD'
    }).format(cents / 100);
  }
  function renderCart(cart, code) {
    lastCart = cart;
    syncWalletDiscount(cart, code);
    const match = (cart.discount_codes || []).find(item => normal(item.code) === normal(code));
    updateCouponButtons(code, Boolean(match));
    const cents = couponSavings(cart, code);
    const hasItems = Number(cart.item_count) > 0;
    const currentItems = productContext ? (cart.items || []).filter(item =>
      String(item.variant_id || item.id) === String(productContext.selectedId)) : [];
    const currentSavings = currentItems.reduce((total, item) => total +
      (item.line_level_discount_allocations || []).reduce((sum, allocation) =>
        sum + (normal(allocation.discount_application?.code || allocation.discount_application?.title) === normal(code) ?
          Number(allocation.amount) || 0 : 0), 0), 0);
    const quantity = currentItems.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    const itemApplied = match?.applicable !== false && currentSavings > 0 && quantity > 0;
    const cartApplied = match?.applicable !== false && cents > 0;

    if (itemApplied) {
      show('applied', code, text.applied, text.productApplied, '', hasItems);
      saving.textContent = text.save + ' ' + formatCurrency(currentSavings / quantity, cart.currency) + ' ' + text.perUnit;
      saving.hidden = false;
      productLabel.textContent = text.onProduct.replace('{product}', productName());
      productLabel.hidden = false;
    } else if (cartApplied) {
      show('applied', code, text.applied, text.ready, formatCurrency(cents, cart.currency), hasItems);
    } else if (match?.applicable === true) {
      show('saved', code, text.accepted, text.checkoutDetails, '', hasItems);
    } else if (match) {
      const absentProduct = productContext && currentItems.length === 0;
      show('saved', code, text.saved, absentProduct ? text.addToCheck : hasItems ? text.notApplied : text.empty, '', hasItems);
      if (absentProduct) {
        productLabel.textContent = text.currentProduct.replace('{product}', productName());
        productLabel.hidden = false;
      }
    } else {
      show('unconfirmed', code, text.unconfirmed, text.retry, '', hasItems);
    }

    if (active && normal(active.code) === normal(code)) {
      active.awaitingItems = !itemApplied && !cartApplied;
      writeState();
    }
    return Boolean(itemApplied || cartApplied);
  }
  async function jsonRequest(path, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, ...options });
      if (!response.ok) throw new Error('Coupon request failed');
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }
  async function refreshWalletDiscount() {
    const revision = walletRevision;
    try {
      const cart = await jsonRequest('cart.js');
      if (revision === walletRevision) syncWalletDiscount(cart);
    } catch (_) {}
  }
  document.addEventListener('cart:updated', event => {
    if (box.dataset.state !== 'pending') syncWalletDiscount(event.detail?.cart);
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshWalletDiscount();
  });
  refreshWalletDiscount();
  function apply(code, requestId) {
    queue = queue.catch(() => {}).then(async () => {
      if (requestId !== sequence) return;
      try {
        const before = await jsonRequest('cart.js');
        if (requestId !== sequence) return;
        const codes = [...new Set([...(before.discount_codes || []).map(item => item.code), code])];
        const cart = await jsonRequest('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ discount: codes.join(','), sections: ['mini-cart'], sections_url: location.pathname })
        });
        if (requestId !== sequence) return;
        active = { code, at: Date.now(), awaitingItems: true };
        writeState();
        renderCart(cart, code);
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: false } }));
      } catch (_) {
        if (requestId === sequence) {
          updateCouponButtons(code, false);
          show('unconfirmed', code, text.unconfirmed, text.retry, '', false);
        }
      }
    });
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const inlineCoupon = target?.closest('button[data-igk-coupon-code]');
    const coupon = target?.closest('a.aph_bar_coupon, a.aph_collapse_coupon, a.aph_pop_coupon');
    if (!coupon && !inlineCoupon) return;
    const code = inlineCoupon?.dataset.igkCouponCode?.trim() || coupon?.querySelector('span')?.textContent.trim();
    if (!code || code.length > 100) return;
    if (box.dataset.state === 'pending' && normal(active?.code) === normal(code)) return;
    const requestId = ++sequence;
    setWalletDiscount(code);
    dismissed = false;
    active = { code, at: Date.now(), awaitingItems: true };
    updateCouponButtons(code, false, true);
    show('pending', code, text.applying, '', '', false);
    if (inlineCoupon || !window.jQuery) { apply(code, requestId); return; }
    const jq = window.jQuery;
    const namespace = '.igkCoupon' + requestId;
    let handled = false;
    let timeout;
    const complete = () => {
      if (handled) return;
      handled = true;
      clearTimeout(timeout);
      jq(document).off(namespace);
      apply(code, requestId);
    };
    jq(document).on('ajaxComplete' + namespace, (_event, _xhr, settings) => {
      try {
        const url = new URL(settings.url, location.href);
        const value = url.pathname.match(/\/discount\/([^/]+)/);
        if (url.origin === location.origin && value && normal(decodeURIComponent(value[1])) === normal(code)) complete();
      } catch (_) {}
    });
    timeout = setTimeout(complete, 6500);
  }, true);
  document.addEventListener('variant:changed', event => {
    const variant = event.detail?.variant;
    if (!productContext || !variant || !productContext.variants.some(item => String(item.id) === String(variant.id))) return;
    productContext.selectedId = variant.id;
    const current = productContext.variants.find(item => String(item.id) === String(variant.id));
    if (Number.isFinite(variant.price)) current.price = variant.price;
    if (typeof variant.available === 'boolean') current.available = variant.available;
    if (active && lastCart && !box.hidden) renderCart(lastCart, active.code);
  }, true);
  box.querySelector('.igk-coupon-feedback__close').addEventListener('click', hide);
  box.addEventListener('mouseenter', () => clearTimeout(dismissTimer));
  box.addEventListener('mouseleave', scheduleHide);
  box.addEventListener('focusin', () => clearTimeout(dismissTimer));
  box.addEventListener('focusout', event => { if (!box.contains(event.relatedTarget)) scheduleHide(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !box.hidden) hide(); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["igk-hero-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('igk-hero-video')) {
  customElements.define('igk-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.poster = this.querySelector('img');
      this.slide = this.closest('slide-show-item');
      this.button = this.slide.querySelector('.igk-hero-video-toggle');
      this.mobile = matchMedia('(max-width: 999px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.inView = this.isInView();
      this.userPaused = false;
      this.optedIn = false;
      this.blocked = false;
      this.failed = false;
      this.pending = false;
      this.retries = 0;
      this.generation = 0;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.button.hidden = false;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.video.paused && !this.blocked && !this.failed) {
          this.userPaused = true;
          this.video.autoplay = false;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.optedIn = true;
          this.blocked = false;
          this.failed = false;
          this.retries = 0;
          this.sync();
        }
      }, options);
      this.poster?.addEventListener('load', () => this.updatePoster(), options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      this.reduced.addEventListener('change', () => {
        this.optedIn = false;
        this.sync();
      }, options);
      this.connection?.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pageshow', () => {
        this.inView = this.isInView();
        this.blocked = false;
        this.sync();
      }, options);
      const resumeAfterGesture = (event) => {
        if (this.button.contains(event.target)) return;
        if (!this.blocked || this.userPaused || !this.inView) return;
        this.blocked = false;
        this.sync();
      };
      document.addEventListener('touchstart', resumeAfterGesture, { ...options, passive: true });
      document.addEventListener('pointerdown', resumeAfterGesture, { ...options, passive: true });
      document.addEventListener('keydown', resumeAfterGesture, options);
      const reveal = () => {
        if (!this.allowedToPlay() || this.video.paused || this.video.readyState < 2) return;
        this.blocked = false;
        this.failed = false;
        this.setAttribute('data-playing', '');
        this.updateButton();
      };
      this.video.addEventListener('playing', reveal, options);
      this.video.addEventListener('timeupdate', reveal, options);
      this.video.addEventListener('loadeddata', () => { reveal(); this.sync(); }, options);
      this.video.addEventListener('canplay', () => this.sync(), options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('error', () => this.fallback(true), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.sync();
        }, { threshold: 0.01 });
        this.observer.observe(this.slide);
      }
      this.slideObserver = new MutationObserver(() => this.sync());
      this.slideObserver.observe(this.slide, { attributes: true, attributeFilter: ['hidden'] });
      this.sync();
    }
    isInView() {
      const box = this.slide.getBoundingClientRect();
      return box.bottom > 0 && box.top < window.innerHeight && box.width > 0;
    }
    allowedToPlay() {
      return this.inView && !document.hidden && !this.slide.hidden && !this.userPaused &&
        (this.optedIn || (!this.reduced.matches && !this.connection?.saveData));
    }
    updatePoster() {
      const source = this.poster?.currentSrc || this.poster?.src;
      if (source && this.video.poster !== source) this.video.poster = source;
    }
    updateButton() {
      const playing = !this.video.paused && !this.failed && !this.blocked;
      this.button.toggleAttribute('data-playing', playing);
      this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
    }
    fallback(failed) {
      this.failed = failed;
      this.blocked = !failed;
      this.pending = false;
      this.removeAttribute('data-playing');
      this.video.autoplay = false;
      this.video.pause();
      this.updateButton();
    }
    sync() {
      const source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (source !== this.source) {
        this.source = source;
        this.generation++;
        this.pending = false;
        this.failed = false;
        this.blocked = false;
        this.retries = 0;
        clearTimeout(this.retryTimer);
        this.removeAttribute('data-playing');
        this.video.pause();
      }
      this.updatePoster();
      if (!this.allowedToPlay()) {
        this.video.autoplay = false;
        this.video.pause();
        if (this.reduced.matches && !this.optedIn) this.removeAttribute('data-playing');
        return;
      }
      if (!source || this.failed || this.blocked || this.pending) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.autoplay = true;
      if (this.video.getAttribute('src') !== source || this.video.error) {
        this.video.src = source;
        this.video.load();
      }
      if (!this.video.paused) return;
      const generation = this.generation;
      this.pending = true;
      Promise.resolve(this.video.play()).then(() => {
        if (generation !== this.generation) return;
        this.pending = false;
        if (!this.allowedToPlay()) this.video.pause();
      }).catch((error) => {
        if (generation !== this.generation) return;
        this.pending = false;
        if (!this.allowedToPlay()) return;
        if (error.name === 'NotAllowedError') this.fallback(false);
        else if (error.name === 'AbortError' && this.retries < 2) {
          this.retries++;
          clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(() => this.sync(), 200);
        } else this.fallback(true);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      clearTimeout(this.retryTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.slideObserver?.disconnect();
      this.video?.pause();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["igk-product-paypal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('igk-product-paypal')) {
    customElements.define('igk-product-paypal', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.mount(), { once: true });
        } else {
          this.mount();
        }
      }

      mount() {
        if (!this.isConnected || this.dataset.ready === 'true') return;
        const paymentTemplate = this.querySelector('template[data-igk-paypal-product]');
        const walletTemplate = this.querySelector('template[data-igk-paypal-wallets]');
        const productButton = paymentTemplate?.content.querySelector('shopify-accelerated-checkout');
        const cartButtons = walletTemplate?.content.querySelector('shopify-accelerated-checkout-cart');
        if (!productButton || !cartButtons) {
          this.hidden = true;
          return;
        }

        try {
          const wallets = JSON.parse(cartButtons.getAttribute('wallet-configs') || '[]');
          const paypal = wallets.find(wallet => wallet.name === 'paypal');
          if (!paypal || !paypal.wallet_params) {
            this.hidden = true;
            return;
          }
          productButton.setAttribute('recommended', JSON.stringify(paypal));
          this.dataset.ready = 'true';
          this.replaceChildren(paymentTemplate.content);
          this.hidden = false;
          this.dispatchEvent(new CustomEvent('igk:paypal-ready', { bubbles: true }));
        } catch {
          this.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:changed', (event) => {
    const form = event.target;
    const formId = form instanceof Element ? form.getAttribute('id') : null;
    if (!formId) return;

    document.querySelectorAll('.product-meta--igk-inline-price').forEach((meta) => {
      if (meta.getAttribute('form-id') !== formId) return;

      meta.querySelectorAll('.igk-price-shipping').forEach((message) => message.remove());

      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.requires_shipping) return;

      const price = meta.querySelector('[data-product-price-list] > .price--large:not(.price--THEM)');
      if (!price) return;

      const message = document.createElement('span');
      message.className = 'igk-price-shipping';
      message.textContent = '+ ' + meta.dataset.igkFreeShipping;
      price.append(message);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
